/* 
 *  Created by SGiri 02/19/2018
 */

import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { MatDialog } from '@angular/material';
import { AppUtil } from '~util/app.util';
import { SearchService } from '~config/services/search.service';
import { Constants } from '~util/app.constant';
import { DialogComponent } from '~config/dashboard-detail/dialog/dialog.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {


  form : FormGroup;
  gridOptions: GridOptions;
  columnDefs: any[]
  rowData: any[];
  style: {};
  isDisabled: boolean = false;
  releases: string[];
  types: any[];


  constructor(private util: AppUtil, private service: SearchService, private dialog: MatDialog) { }

  ngOnInit() {
    this.gridOptions = this.util.getGridOptions('No data to display. Please provide valid search param');
    this.columnDefs = this.getColumnDef();
    this.style = Constants.gridStyle;
    this.rowData = [];
    this.service.getReleaseVersions(false).subscribe((data: string[]) => {
      this.releases = data;
    });

    this.types = this.service.getSearchTypes();

    this.form = new FormGroup({
      searchType: new FormControl('NAME'),
      searchParam: new FormControl(),
      fromDate: new FormControl(),
      toDate: new FormControl(new Date()),
    })

    this.form.controls.searchType.valueChanges.subscribe(value => {
      this.form.controls.searchParam.setValue(null);
    })
  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }

  getRowData(search: any) {
    this.service.getSearchData(search).subscribe((data: any[]) => {
      this.rowData = data;
    });
  }

  getColumnDef() {
    return [
      { headerName: "#", valueGetter: this.getIndex, width: 50 },
      { headerName: "Component Type", field: "compType" },
      { headerName: "Component Name", field: "compName" },
      { headerName: "Component Parent", field: "compParent" },
      { headerName: "Created Date", field: "createdDate", valueFormatter: this.util.dateFormatter },
      { headerName: "Modified Date", field: "modifiedDate", valueFormatter: this.util.dateFormatter },
    ];
  }

  exportToCSV() {
    this.gridOptions.api.exportDataAsCsv();
  }

  search() {

    if ((this.form.controls.searchType.value === 'DC' || this.form.controls.searchType.value === 'DM') && !this.form.controls.fromDate.value) {
      this.form.controls.fromDate.setErrors({ required: true });
      return;
    } else if (this.form.controls.searchType.value === 'RV' && !this.form.controls.searchParam.value) {
      this.form.controls.searchParam.setErrors({ required: true });
      return;
    } else if (this.form.controls.searchType.value === 'NAME' && (!this.form.controls.searchParam.value || this.form.controls.searchParam.value.length < 2)) {
      this.form.controls.searchParam.setErrors({ required: true });
      return;
    }

    let search = this.form.value;

    this.gridOptions.api.showLoadingOverlay();
    this.getRowData(search);
  }

  getIndex(params) {
    return Number.parseInt(params.node.id) + 1;
  }

  exportForRelease() {
    let dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: { dashboard: false }
    });
  }

}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/search/search.component.ts